export default [
    { string_id: 'read', name: 'Read' },
    { string_id: 'create', name: 'Create' },
    { string_id: 'update', name: 'Update' },
    { string_id: 'delete', name: 'Delete' },
    { string_id: 'download', name: 'Download' },
    { string_id: 'review', name: 'Review' },
    { string_id: 'update_clickip_unique', name: 'Update clickip unique' },
    { string_id: 'append_triggers', name: 'Append triggers' },
    { string_id: 'update_since_click', name: 'Update since click' },
    { string_id: 'update_msisdn_unique', name: 'Update msisdn unique' },
    { string_id: 'update_fire_ratio', name: 'Update fire ratio' },
    { string_id: 'update_fire_cap', name: 'Update fire cap' },
    { string_id: 'update_delay', name: 'Update delay' },
    { string_id: 'read_fire_ratio', name: 'Read fire ratio' },
    { string_id: 'read_triggers', name: 'Read triggers' },
    { string_id: 'update_user', name: 'Update user' },
    { string_id: 'change_owner', name: 'Change owner' },
    { string_id: 'change_status', name: 'Change status' },
];
